import { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { message, Popover } from 'antd';
import { Button, Row, Col, Modal, Input, Spin } from 'antd';
import debounce from 'lodash.debounce';
import api from '@/api/coupon';
import Pagination from '@/components/pagination';
import { OnlineCouponItem } from '@/typings/allType';
import { searchIcon } from '@/constants/static';
import couponApi from '@/api/coupon';
import { handleExportUsageData } from '@/utils/publicMethod';
import { couponStatus } from '@/constants/selectOptions';

const OnlineCoupons = () => {
    const link = useNavigate();
    const [loading, setLoading] = useState(false);
    const [listParams, setListParams] = useState<any>({
        pageNum: 1,
        pageSize: 10,
        couponListType: 'NotStartedActive',
        keyword: '',
    });
    const [tableData, setTableData] = useState<OnlineCouponItem[]>([]);
    const inputChange = e => {
        debouncedSave({ ...listParams, keyword: e.target.value, pageNum: 1 });
    };
    const debouncedSave = useCallback(
        debounce(nextValue => setListParams(nextValue), 1500),
        []
    );
    async function getCoupons() {
        setLoading(true);
        try {
            const res = await api.getOnlineCouponList(listParams);
            setTableData(res.data.records);
            setTotals({ ...res.data.metaData, currentTotal: res.data.total });
        } catch (error: any) {
            message.error(error);
        } finally {
            setLoading(false);
        }
    }
    const handlePageChange = prop => {
        setListParams(state => ({ ...state, pageNum: prop }));
    };
    useEffect(() => {
        getCoupons();
    }, [listParams]);
    const [totals, setTotals] = useState({ notStartedActiveTotal: 0, expiredAllUsedTotal: 0, currentTotal: 0 });
    const [tableTabs, setTableTabs] = useState([
        { label: 'Not started, Active', value: 'notStartedActiveTotal', key: 'NotStartedActive' },
        { label: 'Expired, All used', value: 'expiredAllUsedTotal', key: 'ExpiredAllUsed' },
    ]);
    const toInfo = (type: number) => {
        link(`/online-coupon-info?st=${type}`);
    };
    const [pauseId, setPauseId] = useState('');
    const [pauseing, setPauseing] = useState(false);
    const pause = async () => {
        setPauseing(true);
        try {
            await couponApi.pauseCoupon('coupon', pauseId);
            setListParams(state => ({ ...state, pageNum: 1 }));
            setPauseId('');
        } catch (error: any) {
            message.error(error);
        } finally {
            setPauseing(false);
        }
    };
    const [visiblePop, setVisiblePop] = useState(-1);
    const formatDate = (s: string, e: string) => {
        if (!s || !e) return '-';
        const startDate = window.utils.formatTimeMDY(s);
        const endDate = window.utils.formatTimeMDY(e);
        if (startDate === endDate) {
            return startDate;
        } else {
            return `${startDate} - ${endDate}`;
        }
    };
    return (
        <>
            <div className="page-main account">
                <div className="select-bar" style={{ columnGap: 10, marginTop: 0 }} id="select-bar">
                    <div className="page-title">Online Coupons</div>
                    <div style={{ marginLeft: 'auto' }}>
                        <Input
                            className="search-input"
                            placeholder="Search"
                            style={{ width: 250 }}
                            onChange={inputChange}
                            prefix={searchIcon}
                        />
                    </div>
                    <Button
                        type="primary"
                        size="small"
                        className="flex-center"
                        style={{
                            height: 46,
                            width: 152,
                            borderRadius: 8,
                        }}
                        onClick={() => toInfo(0)}
                        icon={<></>}
                    >
                        <img src={require('@/assets/images/add-icon.png')} alt="" />
                        New Coupon
                    </Button>
                </div>
                {
                    <div className="table">
                        <div className="tabs-table">
                            {tableTabs.map((t, index) => {
                                return (
                                    <div
                                        className={`tabs-table-item ${
                                            t.key === listParams.couponListType ? 'tabs-table-item-active' : ''
                                        }`}
                                        key={t.value}
                                        onClick={() =>
                                            setListParams(state => ({ ...state, pageNum: 1, couponListType: t.key }))
                                        }
                                    >
                                        {t.label} ({totals[t.value] || 0})
                                    </div>
                                );
                            })}
                        </div>
                        {loading ? (
                            <div className="data_loading flex-center">
                                <Spin />
                            </div>
                        ) : (
                            <>
                                {tableData.length ? (
                                    <>
                                        <div className="table-th">
                                            <Row>
                                                <Col span={8}>Title</Col>
                                                <Col span={6}>Validity</Col>
                                                <Col span={4}>Quantity</Col>
                                                <Col span={4}>Status</Col>
                                                <Col span={2}>Options</Col>
                                            </Row>
                                        </div>
                                        {tableData.map((item, index) => (
                                            <Row className="table-tr" key={item.couponId}>
                                                <Col span={8}>{item.couponName}</Col>
                                                <Col span={6}>
                                                    {item.validityType === 'permanentlyValid'
                                                        ? 'Permanently valid'
                                                        : formatDate(item.beginDate, item.endDate)}
                                                </Col>
                                                <Col span={4}>{item.quantity}</Col>
                                                <Col
                                                    span={4}
                                                    style={{
                                                        color: (item.status && couponStatus[item.status]?.color) || '',
                                                    }}
                                                >
                                                    {item.status}
                                                </Col>
                                                <Col span={2}>
                                                    <Popover
                                                        open={visiblePop === index}
                                                        onOpenChange={v => setVisiblePop(v ? index : -1)}
                                                        placement="bottomRight"
                                                        content={
                                                            <div className="view-more" style={{ width: 140 }}>
                                                                <div
                                                                    onClick={() => {
                                                                        setVisiblePop(-1);
                                                                        link(
                                                                            `/coupon-detail?st=coupon&stv=${window.btoa(
                                                                                item.couponId
                                                                            )}`
                                                                        );
                                                                    }}
                                                                >
                                                                    View details
                                                                </div>
                                                                <div
                                                                    onClick={() => {
                                                                        handleExportUsageData(
                                                                            'coupon',
                                                                            item.couponId,
                                                                            item.couponName
                                                                        );
                                                                    }}
                                                                >
                                                                    Export Usage Data
                                                                </div>
                                                                {(item.status === 'Active' ||
                                                                    item.status === 'Not Started') && (
                                                                    <div
                                                                        onClick={() => {
                                                                            setPauseId(item.couponId);
                                                                        }}
                                                                    >
                                                                        Pause
                                                                    </div>
                                                                )}
                                                            </div>
                                                        }
                                                    >
                                                        <img
                                                            style={{
                                                                width: 24,
                                                                height: 24,
                                                                cursor: 'pointer',
                                                                textAlign: 'right',
                                                            }}
                                                            src={require('@/assets/images/view-more.png')}
                                                            alt=""
                                                        />
                                                    </Popover>
                                                </Col>
                                            </Row>
                                        ))}
                                        <Pagination
                                            total={totals.currentTotal}
                                            pageChange={handlePageChange}
                                            pageNo={listParams.pageNum}
                                        />
                                    </>
                                ) : (
                                    <div className="no-data flex-center">No data</div>
                                )}
                            </>
                        )}
                    </div>
                }
            </div>
            <Modal
                width={440}
                maskClosable={false}
                centered={true}
                open={pauseId ? true : false}
                onCancel={() => setPauseId('')}
                closeIcon={<img src={require('@/assets/images/Icons_Cross.png')} style={{ width: 24, height: 24 }} />}
            >
                <div className="modal-title" style={{ marginTop: 37 }}>
                    Expire coupons?
                </div>
                <div className="modal-tip tip-font-16">
                    All unused coupons will immediately expire, and this action cannot be undone.
                    <br />
                    <br />
                    Coupons that have already been redeemed will remain valid and cannot be reversed.
                </div>
                <div className="flex-center" style={{ marginTop: 30, columnGap: 20 }}>
                    <Button style={{ width: 138, height: 46 }} onClick={() => setPauseId('')} className="cancel-btn">
                        Cancel
                    </Button>
                    <Button style={{ width: 138, height: 46 }} loading={pauseing} danger type="primary" onClick={pause}>
                        Pause
                    </Button>
                </div>
            </Modal>
        </>
    );
};

export default OnlineCoupons;
